export const DIRECTIONS = {
  RIGHT: "right",
  LEFT: "left",
  TOP: "top",
  BOTTOM: "bottom",
} as const

export type Direction = (typeof DIRECTIONS)[keyof typeof DIRECTIONS]
